import { render, staticRenderFns } from "./viewAndUploadPOD.vue?vue&type=template&id=4666630c&scoped=true"
import script from "./viewAndUploadPOD.vue?vue&type=script&lang=js"
export * from "./viewAndUploadPOD.vue?vue&type=script&lang=js"
import style0 from "./viewAndUploadPOD.vue?vue&type=style&index=0&id=4666630c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4666630c",
  null
  
)

export default component.exports